<nav aria-label="breadcrumb">
    <ol class="breadcrumb m-1">
        <ng-container *ngFor="let bc of breadcrumbs; let last = last">

            <!-- Breadcrumb con video de lengua de señas -->
            <li
                *ngIf="bc.videoSrc; else normalCrumb"
                class="breadcrumb-item"
                [class.active]="last"
                [attr.aria-current]="last ? 'page' : null"
                appLenguajeSenasVideo
                [videoSrc]="bc.videoSrc"
                posicionVideo="bottom"
            >
                <ng-container *ngIf="!last">
                    <a [routerLink]="bc.url">{{ bc.label | titlecase }}</a>
                </ng-container>
                <ng-container *ngIf="last">
                    {{ bc.label | titlecase }}
                </ng-container>
            </li>

            <!-- Breadcrumb normal, sin directiva -->
            <ng-template #normalCrumb>
                <li class="breadcrumb-item" [class.active]="last" [attr.aria-current]="last ? 'page' : null">
                    <ng-container *ngIf="!last">
                        <a [routerLink]="bc.url">{{ bc.label | titlecase }}</a>
                    </ng-container>
                    <ng-container *ngIf="last">
                        {{ bc.label | titlecase }}
                    </ng-container>
                </li>
            </ng-template>

        </ng-container>
    </ol>
</nav>